// @flow

import * as React from 'react';

import { superpathjoin } from 'superpathjoin';

import { useTranslator } from '@gandi/translate';
import { Action } from '@gandi/ui/deprecated';

import { useAssetPath } from 'gandi.react-asset-path';

import { useAppSelector } from 'src/hooks';

import { Intro } from '../../Layout';

import { selectAdminURL } from '../../modules/config';

import { CallToAction } from './CallToAction';

import styles from './EmptyCart.scss';

export function EmptyCart(): React.MixedElement {
  const { __ } = useTranslator();

  const adminUrl = useAppSelector(selectAdminURL);
  const emptyCartImg = useAssetPath('img/empty-cart.png');
  const emptyCartImgX2 = useAssetPath('img/empty-cart@2x.png');

  const dashboardURL = superpathjoin(adminUrl, 'dashboard');

  return (
    <div>
      <Intro title={__('Your shopping cart is empty.')} />
      <CallToAction />
      <Action href={dashboardURL} variant="block" icon="arrowRight">
        {__('Go to dashboard')}
      </Action>
      <img
        className={styles['gad-e']}
        src={emptyCartImg}
        srcSet={[`${emptyCartImg} 1x`, `${emptyCartImgX2} 2x`].join(',')}
        alt=""
      />
    </div>
  );
}
